import React, { ReactNode } from 'react'
import {
  Body,
  Center,
  CenteredBody,
  Footer,
  FooterButton,
  FooterText,
  Header,
  Left,
  Outer,
  Right,
  Row,
} from './two-column-step-layout.styled'
import useFlow from 'modules/flow/state/use-flow'
import Drawer from 'modules/drawer/components/drawer/drawer'
import useConfig from 'modules/config/state/use-config'
import { TwoColumnStepLayoutFAQToggle } from './components/two-column-step-layout-faq-toggle'
import { THANK_YOU_STEP_NAME } from 'modules/flow/state/utils/steps/thank-you'
import { useRightPanelComponent } from './two-column-step-layout.utils'

interface FlowTwoColumnStepLayoutProps {
  children: ReactNode
}

const FlowTwoColumnStepLayout = React.memo(({ children }: FlowTwoColumnStepLayoutProps) => {
  const flow = useFlow()
  const config = useConfig()
  const isThankYouStep = flow.currentStep.name === THANK_YOU_STEP_NAME

  const RightPanelComponent = useRightPanelComponent()

  if (RightPanelComponent) {
    return (
      <Row>
        <Left>
          <Outer>
            {children}
            {!isThankYouStep && (
              <TwoColumnStepLayoutFAQToggle
                hasContentPanel={!!config.contentPanel}
                hyperlink={config?.hyperlink}
              />
            )}
          </Outer>
          <Drawer position="left" direction="bottomToTop" />
        </Left>
        <Right>
          <RightPanelComponent />
          <Drawer position="right" direction="leftToRight" />
        </Right>
      </Row>
    )
  }

  return (
    <Center>
      <Outer>
        {children}
        {!isThankYouStep && (
          <TwoColumnStepLayoutFAQToggle
            hasContentPanel={!!config.contentPanel}
            hyperlink={config?.hyperlink}
          />
        )}
      </Outer>
      <Drawer position="center" direction="bottomToTop" />
    </Center>
  )
}) as React.MemoExoticComponent<React.FC<FlowTwoColumnStepLayoutProps>> & {
  Header: typeof Header
  Body: typeof Body
  CenteredBody: typeof CenteredBody
  Footer: typeof Footer
  FooterText: typeof FooterText
  FooterButton: typeof FooterButton
}

// Reassign the static properties after memoizing
FlowTwoColumnStepLayout.displayName = 'FlowTwoColumnStepLayout'
FlowTwoColumnStepLayout.Header = Header
FlowTwoColumnStepLayout.Body = Body
FlowTwoColumnStepLayout.CenteredBody = CenteredBody
FlowTwoColumnStepLayout.Footer = Footer
FlowTwoColumnStepLayout.FooterText = FooterText
FlowTwoColumnStepLayout.FooterButton = FooterButton

export default FlowTwoColumnStepLayout
